import { toastManager } from "@hulahoop/ui";
import { useToastStore } from "@/stores/useToastStore";

/** Keep rescued callers and analytics on the store; render and dismiss through the DS. */
export function connectDsToasts() {
  let connected = true;
  let ids = new Set<string>();
  const sync = () => {
    const { toasts } = useToastStore.getState();
    const previous = ids;
    ids = new Set(toasts.map(({ id }) => id));
    for (const item of toasts) {
      if (previous.has(item.id)) continue;
      toastManager.add({
        id: item.id,
        type: item.type,
        title: item.title ?? item.message,
        description: item.title ? item.message : undefined,
        actionProps: item.action
          ? { children: item.action.label, onClick: item.action.onClick }
          : undefined,
        // The store owns existing caller durations, including persistent toasts.
        timeout: 0,
        onClose: () => {
          if (connected) useToastStore.getState().dismissToast(item.id);
        },
      });
    }
    for (const id of previous) if (!ids.has(id)) toastManager.close(id);
  };
  const unsubscribe = useToastStore.subscribe(sync);
  sync();
  return () => {
    connected = false;
    unsubscribe();
    for (const id of ids) toastManager.close(id);
  };
}
